import { Flex, HStack } from "@chakra-ui/react";
import React from "react";

import { WizardStep } from "./AiInterviewerWizardContext";
import AiInterviewerWizardControls from "./AiInterviewerWizardControls";
import AiInterviewerWizardStepper from "./AiInterviewerWizardStepper";

interface AiInterviewerWizardProps {
  step: number; // zero-indexed
  steps: WizardStep[];
  readOnly?: boolean;
}

const AiInterviewerWizard: React.FC<AiInterviewerWizardProps> = ({
  step,
  steps,
  readOnly,
}) => {
  return (
    <Flex py="4" px="64px" bg="blueAlpha.900">
      <HStack spacing="10">
        <AiInterviewerWizardStepper steps={steps} currentStep={step} />
        <AiInterviewerWizardControls
          steps={steps}
          currentStep={step}
          readOnly={readOnly}
        />
      </HStack>
    </Flex>
  );
};

export default AiInterviewerWizard;
